import { createEntityAdapter, createSelector, createSlice } from '@reduxjs/toolkit';

import { userInfosApi } from 'redux/api/userInfos.api';

const usersAdapter = createEntityAdapter({
  selectId: user => user.user_id,
});

const usersSlice = createSlice({
  name: 'usersSlice',
  initialState: usersAdapter.getInitialState(),
  reducers: {},
  extraReducers: builder => {
    builder.addMatcher(userInfosApi.endpoints.fetchUsersList.matchFulfilled, (state, action) => {
      usersAdapter.upsertMany(state, action.payload.users);
    });
  },
});

export default usersSlice.reducer;

export const {
  selectById: selectUserById,
  selectAll: selectAllUsers,
  selectEntities: selectUsersEntities,
} = usersAdapter.getSelectors(state => state.usersSlice);

export const selectUsersByIds = createSelector(
  [selectUsersEntities, (_, userIds) => userIds],
  (entities, userIds) => {
    if (!userIds?.length) return [];
    return userIds.map(userId => entities[userId]);
  },
);

export const selectMissingUserIds = createSelector(
  [selectUsersEntities, (_, userIds) => userIds],
  (entities, userIds) => {
    if (!userIds?.length) return [];
    return userIds.filter(userId => !entities[userId]);
  },
);
